// @unocss-include
import { getRgbOfColor } from '@sa/utils';
import { localStg } from '@/utils/storage';
import avalaiAnimated from '@/assets/svg-icon/avalai-animated.svg?raw';
export function setupLoading() {
  const themeColor = localStg.get('themeColor') || '#646cff';

  const { r, g, b } = getRgbOfColor(themeColor);

  const primaryColor = `--primary-color: ${r} ${g} ${b}`;

  const logoWithClass = avalaiAnimated.replace('<svg', `<svg class="size-128px text-primary"`);

  const loading = `
<div class="fixed-center flex-col" style="${primaryColor}">
  ${logoWithClass}
  <div class="loading-bar"></div>
</div>`;

  const app = document.getElementById('app');

  if (app) {
    app.innerHTML = loading;
  }
}
